<template lang='pug'>
  v-combobox(
    :label='label'
    @input='update'
    :value='value'
    :items='suites'
    item-text='name'
    :search-input.sync='search'
    return-object
    chips
    multiple
    deletable-chips
    auto-select-first
    small-chips
    cache-items
    clearable
    required
    :rules='required')
    template(v-slot:item='{item}')
      v-list-item-content.ellipsis
        v-list-item-title(v-text='item.name')
        v-list-item-subtitle(v-text='item.description')
    template(v-slot:no-data)
      v-list-item
        v-list-item-content
          v-list-item-title
            | No suites matching &quot;
            strong {{ search }}
            | &quot;

</template>

<script>

export default {
  name: 'SelectSuites',
  props: {
    label: {
      default() {
        return 'Select Suites';
      }
    },
    value: {
      default() {
        return null;
      }
    },
    suites: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    update(value) {
      this.search = null;
      this.$emit('input', value);
    }
  },
  data() {
    return {
      search: null,
      required: [(v) => !!v || 'Required field']
    };
  }
};
</script>

<style scoped>

</style>
